import React from 'react';
import { IApplicantField } from 'components/Forms/Applicant/interfaces';
import { Field } from 'formik';
import { QuoteField } from 'shared/Inputs/Quote/QuoteField';
import { QuoteFieldRebrand } from 'shared/Inputs/Quote/QuoteFieldRebrand';
import { postcodeMask } from 'shared/Inputs/inputMasks';

const QuoteFieldComponent = (rebrand?: boolean) => (rebrand ? QuoteFieldRebrand : QuoteField);

export const PostCode: React.FC<IApplicantField> = ({
  prefix,
  isValid,
  isCorrect,
  label = 'Post Code',
  required,
  disabled,
  handleBlur,
  children,
  useRebrand,
}: IApplicantField) => {
  const transformToUpperCase = (value: string) => value.toUpperCase();

  return (
    <Field
      name={`${prefix}.postcode`}
      isValidNested={isValid('postcode')}
      isCorrectNested={isCorrect('postcode')}
      labelText={label}
      component={QuoteFieldComponent(useRebrand)}
      mask={postcodeMask}
      required={required}
      disabled={disabled}
      handleBlur={handleBlur}
      transformValue={transformToUpperCase}>
      {children}
    </Field>
  );
};

export const FlatNumber: React.FC<IApplicantField> = ({
  prefix,
  isValid,
  isCorrect,
  label = 'Flat number',
  required,
  disabled,
  handleBlur,
  useRebrand,
}: IApplicantField) => (
  <Field
    component={QuoteFieldComponent(useRebrand)}
    isValidNested={isValid('flatNumber')}
    isCorrectNested={isCorrect('flatNumber')}
    placeholder={label}
    name={`${prefix}.flatNumber`}
    required={required}
    disabled={disabled}
    handleBlur={handleBlur}
  />
);

export const BuildingName: React.FC<IApplicantField> = ({
  prefix,
  isValid,
  isCorrect,
  label = 'Building name',
  required,
  disabled,
  handleBlur,
  useRebrand,
}: IApplicantField) => (
  <Field
    component={QuoteFieldComponent(useRebrand)}
    isValidNested={isValid('buildingName')}
    isCorrectNested={isCorrect('buildingName')}
    placeholder={label}
    name={`${prefix}.buildingName`}
    required={required}
    disabled={disabled}
    handleBlur={handleBlur}
  />
);

export const BuildingNumber: React.FC<IApplicantField> = ({
  prefix,
  isValid,
  isCorrect,
  label = 'Building number',
  required,
  disabled,
  handleBlur,
  useRebrand,
}: IApplicantField) => (
  <Field
    component={QuoteFieldComponent(useRebrand)}
    isValidNested={isValid('buildingNumber')}
    isCorrectNested={isCorrect('buildingNumber')}
    placeholder={label}
    name={`${prefix}.buildingNumber`}
    required={required}
    disabled={disabled}
    handleBlur={handleBlur}
  />
);

export const Street: React.FC<IApplicantField> = ({
  prefix,
  isValid,
  isCorrect,
  label = 'Street',
  required,
  disabled,
  handleBlur,
  useRebrand,
}: IApplicantField) => (
  <Field
    component={QuoteFieldComponent(useRebrand)}
    isValidNested={isValid('street')}
    isCorrectNested={isCorrect('street')}
    placeholder={label}
    name={`${prefix}.street`}
    required={required}
    disabled={disabled}
    handleBlur={handleBlur}
  />
);

export const City: React.FC<IApplicantField> = ({
  prefix,
  isValid,
  isCorrect,
  label = 'City',
  required,
  disabled,
  handleBlur,
  useRebrand,
}: IApplicantField) => (
  <Field
    component={QuoteFieldComponent(useRebrand)}
    isValidNested={isValid('city')}
    isCorrectNested={isCorrect('city')}
    labelText=""
    placeholder={label}
    name={`${prefix}.city`}
    required={required}
    disabled={disabled}
    handleBlur={handleBlur}
  />
);

export const County: React.FC<IApplicantField> = ({
  prefix,
  isValid,
  isCorrect,
  label = 'County',
  required,
  disabled,
  handleBlur,
  useRebrand,
}: IApplicantField) => (
  <Field
    component={QuoteFieldComponent(useRebrand)}
    isValidNested={isValid('county')}
    isCorrectNested={isCorrect('county')}
    labelText=""
    placeholder={label}
    name={`${prefix}.county`}
    required={required}
    disabled={disabled}
    handleBlur={handleBlur}
  />
);
